export default __webpack_public_path__ + "static/media/actionServo.9888862b.svg";